.isolate {
    isolation: isolate;
}
